<template>
  <div>
    <PartnerHeader :img_header="header_image" header="แก้ไขโปรโมชั่นแถมราคาถูกสุด" link_back="promotioninformation"/>
    <MenuPartner/>
    <Promotion_edit_pos_free/>
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Promotion_edit_pos_free from "@/components/admin/manage_pos/partner_store_setting/Promotion_edit_pos_free";
export default {
  name: "PromotionEditPosFree",
  components: {
    Promotion_edit_pos_free,
    // MenuPartner,
    PartnerHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
